import { ServerConfig } from "@/config/config";
import { ServerDbService } from "./server-db-service";

class ServerServiceClass {
	public readonly url:string = `${ServerConfig.mainAppHost}/server`
	public dbService:ServerDbService = new ServerDbService(this.url);
}

export const ServerService = new ServerServiceClass();